import { 
    INIT_REGISTRO_PROSPECTO,   
    REGISTRO_PROSPECTO_EXITOSO,
    REGISTRO_PROSPECTO_ERROR,
    INIT_OBTENER_PROSPECTO_EMPRESAPERTENECE,
    OBTENER_PROSPECTO_EMPRESASPERTENECE_EXITOSO,
    OBTENER_PROSPECTO_EMPRESASPERTENECE_ERROR,
    INIT_OBTENER_PROSPECTOS,
    OBTENER_PROSPECTOS_EXITOSO,
    OBTENER_PROSPECTOS_ERROR
 } from '../../../types';

 export default ( state, action ) => {
    switch( action.type ) {
        case INIT_OBTENER_PROSPECTOS:
        case INIT_OBTENER_PROSPECTO_EMPRESAPERTENECE:
        case INIT_REGISTRO_PROSPECTO:
            return {
                ...state,
                requests: state.requests + 1,
                cargando: true
            };
        case REGISTRO_PROSPECTO_EXITOSO:
            return {
                ...state,
                requests: state.requests - 1,
                cargando: false
            };
        case REGISTRO_PROSPECTO_ERROR:
            return {
                ...state,
                requests: state.requests - 1,
                cargando: false,
                error: action.payload
            };
        case OBTENER_PROSPECTO_EMPRESASPERTENECE_EXITOSO:
            return {
                ...state,
                requests: state.requests - 1,
                cargando: false,
                entidadesPadre: action.payload
            };
        case OBTENER_PROSPECTO_EMPRESASPERTENECE_ERROR:
            return {
                ...state,
                requests: state.requests - 1,
                cargando: false,
                entidadesPadre: null,
                error: action.payload
            };
        case OBTENER_PROSPECTOS_EXITOSO:
            return {
                ...state,
                requests: state.requests - 1,
                cargando: false,
                prospectos: action.payload
            };
        case OBTENER_PROSPECTOS_ERROR:
            return {
                ...state,
                requests: state.requests - 1,
                cargando: false,
                prospectos: null,
                error: action.payload
            };
        default:
            return state;
    }
}